import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M607.5 205.5L429 384l178.5 178.5-45 45L384 429 205.5 607.5l-45-45L339 384 160.5 205.5l45-45L384 339l178.5-178.5z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 768 768"
  }, props), _ref);
};

export default SvgComponent;